import React, { useEffect, useRef, useMemo } from 'react';
import '../Style/Bp.css';
import { useLanguage } from '../Context/Languagecontext';

// Static layout & styling properties kept outside render context
const BUSINESS_CONFIG = [
  { id: 'kkb-garments', num: '01', accent: 'var(--clr-crimson)' },
  { id: 'arun-mills', num: '02', accent: 'var(--clr-gold)' },
  { id: 'kkb-group', num: '03', accent: 'var(--clr-crimson-deep)' },
];

const BPortfolio = () => {
  const cardsRef = useRef([]);
  const { t, lang } = useLanguage();
  const portfolioData = t.businessPortfolio;

  /* ── Join language copies with the style structure configuration arrays ── */
  const localizedBusinesses = useMemo(() => {
    const rawData = portfolioData?.businesses || {};
    return BUSINESS_CONFIG.map((config) => {
      const copy = rawData[config.id] || {};
      return {
        ...config,
        tag: copy.tag || '',
        name: copy.name || '',
        tagline: copy.tagline || '',
        description: copy.description || '',
        points: copy.points || [],
      };
    });
  }, [portfolioData]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('bp-card--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    cardsRef.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, [localizedBusinesses]); // Re-attach observers if localized values alter layout array instances

  return (
    <section className={`bp-section ${lang === 'ta' ? 'bp-section--tamil' : ''}`}>
      {/* subtle decorative line */}
      <div className="bp-deco-line" aria-hidden="true" />

      <div className="bp-inner">
        <div className="bp-header">
          <p className="bp-eyebrow">{portfolioData?.eyebrow}</p>
          <h2 className="bp-heading">{portfolioData?.heading}</h2>
          <p className="bp-subhead">{portfolioData?.subhead}</p>
        </div>

        <div className="bp-grid">
          {localizedBusinesses.map((biz, i) => (
            <article
              key={biz.id}
              className="bp-card"
              ref={(el) => (cardsRef.current[i] = el)}
              style={{ 
                '--bp-accent': biz.accent, 
                '--bp-delay': `${i * 0.12}s` 
              }}
            >
              <div className="bp-card-top">
                <span className="bp-num">{biz.num}</span>
                <span className="bp-tag">{biz.tag}</span>
              </div>

              <div className="bp-card-body">
                <h3 className="bp-name">{biz.name}</h3>
                <p className="bp-tagline">{biz.tagline}</p>
                <p className="bp-desc">{biz.description}</p>
              </div>

              <ul className="bp-points">
                {biz.points.map((pt, index) => (
                  <li key={pt.label || index} className="bp-point">
                    <span className="bp-point-label">{pt.label}</span>
                    <span className="bp-point-value">{pt.value}</span>
                  </li>
                ))}
              </ul>

              <div className="bp-card-bar" aria-hidden="true" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BPortfolio;